<template>
  <LayoutDefault>
    <section class="basic-information">
      <h1 class="basic-information__title">Основные сведения</h1>
      <table class="basic-information__table">
        <thead>
          <tr>
            <th class="basic-information__table-title">Категории</th>
            <th class="basic-information__table-title">Наполнение</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in basicInformation?.Block1" :key="idx">
            <td class="basic-information__categories">
              <Textarea
                v-model="item.Name"
                autoResize rows="1"
                cols="70"
                placeholder="Название"
              />
            </td>
            <td class="basic-information__filling">
              <ckeditor
                :editor="editor"
                :config="editorConfig"
                v-model="item.Description"
              />
            </td>
            <td>
              <CloseIcon @click="removeBlockBasicInformation(item.GUID, item.Id)" />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="basic-information__button-adder">
        <BaseBtn
        blue
        plus
        text="Добавить поле"
        @click="addBlockBasicInformation"
      />
      </div>
      <div class="basic-information__buttons">
        <BaseBtn
          blue
          text="Сохранить"
          @click="updateBasicInformation"
        />

        <BaseBtn
          blue
          text="Отменить"
          @click="cancelСhangesBasicInformation"
        />
      </div>
    </section>
  </LayoutDefault>
</template>

<script>
import { onMounted, computed, ref } from 'vue'
import { useStore } from 'vuex'

import LayoutDefault from '@/layout/LayoutDefault'
import BaseBtn from '@/components/ui/BaseBtn.vue'
import CloseIcon from '@/components/icons/CloseIcon.vue'

import Textarea from 'primevue/textarea'

import Editor from 'ckeditor5-custom-build/build/ckeditor'

export default {
  name: 'BasicInformationView',
  components: {
    LayoutDefault,
    BaseBtn,
    CloseIcon,
    Textarea
  },
  props: {
  },
  setup () {
    const store = useStore()

    const editor = ref(Editor)
    const editorConfig = ref({})

    onMounted(() => {
      // запрашиваем данные при монтировании компонента
      store.dispatch('setBasicInformationData')
    })

    const basicInformation = computed(() => {
      return store.getters.getBasicInformationData
    })

    // функция генерирующая GUID (уникальный номер) для того, чтобы можно было создавать объекты с каким-то уникальным значением и удалять их по нему на стороне фронта, а на бек отправлять только итоговые данные
    function uuidv4 () {
      return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
      )
    }

    // создание нового объекта поля на стороне фронта
    const addBlockBasicInformation = () => {
      // сохраням возвращенное значение из функции uuidv4 в переменную и впоследующем используем ее как свойство объекта
      const saveUiid = uuidv4()

      const obj = {
        Id: 0,
        Name: '',
        Description: '',
        BlockIndex: 1,
        SectionId: 1,
        GUID: saveUiid
      }

      store.commit('SetAddBlockBasicInformation', obj)
    }

    // запрос на удаление поля информации
    const removeBlockBasicInformation = (GUID, Id) => {
      // проверка есть ли у объекта GUID, так как GUID только у объектов созданных на стороне фронта
      // если GUID есть, то удаляем созданное на стороне фронта поле, если нет, то удаляем пришедшее с бека поле по Id
      if (GUID !== undefined) {
        store.commit('SetRemoveBlockBasicInformation', GUID)
      } else {
        store.commit('SetRemoveBlockBasicInformation', Id)
      }
    }

    // запрос отправляет измененные данные на сервер
    const updateBasicInformation = () => {
      store.dispatch('setUpdateBasicInformation', basicInformation.value)
    }

    const cancelСhangesBasicInformation = () => {
      // при отмене, получаем с бека исходные данные
      store.dispatch('setBasicInformationData')
    }

    return {
      editor,
      editorConfig,
      basicInformation,
      addBlockBasicInformation,
      removeBlockBasicInformation,
      updateBasicInformation,
      cancelСhangesBasicInformation,
      uuidv4
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-information {
  &__title {
    @include information-block-title;
    margin-bottom: 16px;
  }

  &__table {
    text-align: left;
    border-spacing: 0 8px;
    margin-bottom: 50px;
  }

  &__table-title {
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 8px;
  }

  &__categories {
    padding-right: 16px;

    :deep(.p-inputtextarea) {
      width: 300px;
      padding: 8px 12px;
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__filling {
    padding-right: 8px;

    :deep(.p-inputtextarea) {
      padding: 8px 12px;
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__buttons {
    display: flex;
    gap: 16px;
    justify-content: flex-end;
    margin-bottom: 20px;
  }

  &__button-adder {
    display: flex;

    :deep(.blue-button) {
      display: flex;
      align-items: center;
      gap: 13px;
      width: 180px;
      font-size: 16px;
      border-radius: 8px
    }
  }

  :deep(.ck.ck-editor) {
    width: 450px;
    }

    :deep(.ck.ck-editor__main ) {
      font-size: 14px;
    }
}
</style>
